import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/vecura-logo.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-7ccefcce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile-vecura" }
const _hoisted_2 = { class: "mobile-vecura__hero" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Vecura"
}, null, -1))
const _hoisted_4 = { class: "mobile-vecura__section mobile-vecura__role" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Meine Rolle"),
  /*#__PURE__*/_createElementVNode("h2", null, "Aufbau, Richtung und operative Verantwortung.")
], -1))
const _hoisted_6 = { class: "mobile-vecura__section" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Plattform", -1))
const _hoisted_8 = {
  class: "mobile-vecura__stats",
  "aria-label": "Vecura Kennzahlen"
}
const _hoisted_9 = { class: "mobile-vecura__section" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Leistung"),
  /*#__PURE__*/_createElementVNode("h2", null, "Daten, Suche, Quellen und Integration müssen zusammenarbeiten.")
], -1))
const _hoisted_11 = { class: "mobile-vecura__capabilities" }
const _hoisted_12 = ["aria-expanded", "onClick"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "mobile-vecura__section mobile-vecura__case" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Case Study", -1))
const _hoisted_16 = { class: "mobile-vecura__section mobile-vecura__contact" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Kontakt"),
  /*#__PURE__*/_createElementVNode("h2", null, "Wenn Fachwissen schneller nutzbar werden soll.")
], -1))
const _hoisted_18 = {
  class: "mobile-vecura__icon-actions",
  "aria-label": "Vecura Kontakt"
}
const _hoisted_19 = ["href"]

import { ref } from "vue";
import ContactChannelIcon from "@/components/icons/ContactChannelIcon.vue";
import MobileSymbolIcon from "@/components/icons/MobileSymbolIcon.vue";
import { vecuraPage } from "@/data/profile";
import { createMailtoHref, vecuraEmail } from "@/utils/contact";

const vecuraWebsiteUrl = "https://vecura.io";
const vecuraLinkedinUrl = "https://www.linkedin.com/company/vecura-gmbh";

export default /*#__PURE__*/_defineComponent({
  __name: 'MobileVecuraPage',
  setup(__props) {

const vecuraEmailHref = createMailtoHref(vecuraEmail);
const openCapabilityTitles = ref<Set<string>>(
  new Set(vecuraPage.capabilities[0] ? [vecuraPage.capabilities[0].title] : [])
);

function isCapabilityOpen(title: string): boolean {
  return openCapabilityTitles.value.has(title);
}

function getCapabilityState(title: string): Record<string, boolean> {
  return {
    "mobile-vecura__capability--open": isCapabilityOpen(title),
  };
}

function toggleCapability(title: string): void {
  const nextOpenTitles = new Set(openCapabilityTitles.value);

  if (nextOpenTitles.has(title)) {
    nextOpenTitles.delete(title);
  } else {
    nextOpenTitles.add(title);
  }

  openCapabilityTitles.value = nextOpenTitles;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", null, _toDisplayString(_unref(vecuraPage).eyebrow), 1),
      _createElementVNode("h1", null, _toDisplayString(_unref(vecuraPage).headline), 1),
      _createElementVNode("span", null, _toDisplayString(_unref(vecuraPage).intro), 1)
    ]),
    _createElementVNode("section", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("p", null, _toDisplayString(_unref(vecuraPage).role), 1),
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vecuraPage).rolePoints, (point) => {
          return (_openBlock(), _createElementBlock("li", { key: point }, _toDisplayString(point), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _createElementVNode("header", null, [
        _hoisted_7,
        _createElementVNode("h2", null, _toDisplayString(_unref(vecuraPage).pitch), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vecuraPage).proofPoints, (point) => {
          return (_openBlock(), _createElementBlock("article", {
            key: point.value
          }, [
            _createElementVNode("strong", null, _toDisplayString(point.value), 1),
            _createElementVNode("span", null, _toDisplayString(point.label), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vecuraPage).capabilities, (capability, index) => {
          return (_openBlock(), _createElementBlock("article", {
            key: capability.title,
            class: _normalizeClass(["mobile-vecura__capability", getCapabilityState(capability.title)])
          }, [
            _createElementVNode("button", {
              class: "mobile-vecura__capability-summary",
              type: "button",
              "aria-expanded": isCapabilityOpen(capability.title),
              onClick: ($event: any) => (toggleCapability(capability.title))
            }, [
              _createVNode(MobileSymbolIcon, {
                type: index === 1 ? 'expertise' : 'brain'
              }, null, 8, ["type"]),
              _createElementVNode("strong", null, _toDisplayString(capability.title), 1)
            ], 8, _hoisted_12),
            _createVNode(_Transition, { name: "mobile-vecura-disclosure" }, {
              default: _withCtx(() => [
                (isCapabilityOpen(capability.title))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(capability.description), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ], 2))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_14, [
      _createElementVNode("header", null, [
        _hoisted_15,
        _createElementVNode("h2", null, _toDisplayString(_unref(vecuraPage).caseStudy.title), 1)
      ]),
      _createElementVNode("p", null, _toDisplayString(_unref(vecuraPage).caseStudy.summary), 1),
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vecuraPage).caseStudy.details, (detail) => {
          return (_openBlock(), _createElementBlock("li", { key: detail }, _toDisplayString(detail), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_16, [
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("a", {
          href: vecuraWebsiteUrl,
          target: "_blank",
          rel: "noopener noreferrer",
          "aria-label": "Vecura Website öffnen"
        }, [
          _createVNode(ContactChannelIcon, { type: "vecura" })
        ]),
        _createElementVNode("a", {
          href: vecuraLinkedinUrl,
          target: "_blank",
          rel: "noopener noreferrer",
          "aria-label": "Vecura auf LinkedIn öffnen"
        }, [
          _createVNode(ContactChannelIcon, { type: "linkedin" })
        ]),
        _createElementVNode("a", {
          href: _unref(vecuraEmailHref),
          "aria-label": "E-Mail an Vecura schreiben"
        }, [
          _createVNode(ContactChannelIcon, { type: "mail" })
        ], 8, _hoisted_19)
      ])
    ])
  ]))
}
}

})